import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '../index'

interface SessionExpirationState {
  isExpired: boolean
}

const initialState: SessionExpirationState = {
  isExpired: false,
}

const sessionExpirationSlice = createSlice({
  name: 'sessionExpiration',
  initialState,
  reducers: {
    setExpired(state) {
      state.isExpired = true
    },
  },
})

export const selectIsSessionExpired = (state: RootState) =>
  state.sessionExpiration.isExpired

export const { setExpired } = sessionExpirationSlice.actions
export default sessionExpirationSlice.reducer
